import { render, staticRenderFns } from "./HeaderBasic.vue?vue&type=template&id=3bc6a792&scoped=true&"
import script from "./HeaderBasic.vue?vue&type=script&lang=js&"
export * from "./HeaderBasic.vue?vue&type=script&lang=js&"
import style0 from "./HeaderBasic.vue?vue&type=style&index=0&id=3bc6a792&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc6a792",
  null
  
)

export default component.exports